import React from "react";
import { Outlet } from "react-router-dom";

import Wrapper from "../components/Wrapper";
import Main from "../components/Main";
import Navbar from "../components/navbar/Navbar";
import Content from "../components/Content";

const Web = ({ children, showNav, styles, mainClassName }) => {
  return (
    <React.Fragment>
      <Wrapper>
        <Main className={mainClassName} style={styles?.main || {}}>
          <Navbar showNav={showNav} />
          <Content>
            {children}
            <Outlet />
          </Content>
          {/* {!showNav && <Footer />} */}
        </Main>
      </Wrapper>
    </React.Fragment>
  );
};

export default Web;
